/* import __COLOCATED_TEMPLATE__ from './similar-conversations.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();